import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Patient } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ALL_PATIENTS_KEY = 'get-all-patients';

export const useGetAllPatients = ({ page = 0, size = 10 }: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Patient[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/patient?page=${page}&size=${size}`,
    {},
    [GET_ALL_PATIENTS_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
